/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreatePromptRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  createPromptRequest: components.CreatePromptRequest;
};

/** @internal */
export const CreatePromptRequest$inboundSchema: z.ZodType<
  CreatePromptRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
  CreatePromptRequest: components.CreatePromptRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "CreatePromptRequest": "createPromptRequest",
  });
});
/** @internal */
export type CreatePromptRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
  CreatePromptRequest: components.CreatePromptRequest$Outbound;
};

/** @internal */
export const CreatePromptRequest$outboundSchema: z.ZodType<
  CreatePromptRequest$Outbound,
  z.ZodTypeDef,
  CreatePromptRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
  createPromptRequest: components.CreatePromptRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    createPromptRequest: "CreatePromptRequest",
  });
});

export function createPromptRequestToJSON(
  createPromptRequest: CreatePromptRequest,
): string {
  return JSON.stringify(
    CreatePromptRequest$outboundSchema.parse(createPromptRequest),
  );
}
export function createPromptRequestFromJSON(
  jsonString: string,
): SafeParseResult<CreatePromptRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreatePromptRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreatePromptRequest' from JSON`,
  );
}
